module.exports = __webpack_public_path__ + "img/eco6.c51fcc75.png";